import { message } from "antd";
import React, { useEffect, useState } from "react";
import { BiPhoneIncoming } from "react-icons/bi";
import { api } from "../../services/api";
import { Load } from "../Load";
import { Content } from "./styles";
import { socket } from "../../services/socket";
import { IWhatsappConnectionInfo, WhatsappConnectionInfo } from "../WhatsappConnectionInfo";
import { WhatsappQrCode } from "../WhatsappQrCode";
import { Button } from "../Button";
import moment from "moment";
interface Props { }
export function WhatsappConnection({ ...rest }: Props) {
  const [loading, setLoading] = useState(true);
  const [whatsapp, setWhatsapp] = useState<IWhatsappConnectionInfo>(
    {} as IWhatsappConnectionInfo
  );
  const [visibleQrCodeGenerator, setVisibleQrCodeGenerator] = useState(false);
  function handleGerenateQrCode() {
    setVisibleQrCodeGenerator(true);
  }
  function fetchData() {
    api
      .get<IWhatsappConnectionInfo>("whatsapp/info")
      .then((response) => {
        setWhatsapp(response.data);
      })
      .catch((e) => {
        message.info(e.response.data.message);
      })
      .finally(() => setLoading(false));
  }
  useEffect(fetchData, []);
  useEffect(() => {
    socket.on("whatsapp_connect_update", () => {
      fetchData();
    });
    socket.on("qr", (qr) => {
      setVisibleQrCodeGenerator(true);
    });
  }, []);
  return (
    <Content>
      <div className="header-conf">
        <span>
          Conexão com o Whatsapp <BiPhoneIncoming />
        </span>
        Última conexão:{" "}
        {whatsapp.status ? moment(whatsapp.createdAt).calendar() : "- : -"}
      </div>
      <div className="main-content">
        {loading ? (
          <Load />
        ) : whatsapp.status ? (
          <WhatsappConnectionInfo {...whatsapp} />
        ) : visibleQrCodeGenerator ? (
          <WhatsappQrCode />
        ) : (
          <Button title="Gerar QrCode" onClick={handleGerenateQrCode} />
        )}
      </div>
    </Content>
  );
}
